import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface IConditionalRouteProps {
    condition: boolean | undefined;
    defaultUrl?: string;
    replace?: boolean;
    state?: any;
}

function ConditionalRoute({ condition, defaultUrl = '', replace, state }: IConditionalRouteProps) {
    if (!condition) {
        return <Navigate to={defaultUrl} state={state} replace={replace} />;
    }

    return <Outlet />;
}

export default ConditionalRoute;
